import { useEffect } from "react";

export const useInViewObserver = (
    ref: React.RefObject<Element>,
    callback?: () => void,
    threshold = 0.5,
) => {
    useEffect(() => {
        if (!ref.current || !callback) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) callback();
            },
            { threshold },
        );

        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [ref, callback, threshold]);
};
